import SenderPersonaForm from "../../_components/SenderPersonaForm";
import { useParams } from "react-router-dom";
import { PageAccessGuard } from "@/components/auth/PageAccessGuard";

const SenderPersonaFormPage: React.FC = () => {
  return (
    <PageAccessGuard authority="ADMIN_SENDER_PERSONA_UPDATE">
      <SenderPersonaFormContent />
    </PageAccessGuard>
  );
};

const SenderPersonaFormContent: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  
  return <SenderPersonaForm mode="edit" personaId={id} />;
};

export default SenderPersonaFormPage;
